module.exports = __webpack_public_path__ + "static/media/data-visualization.c7906e9d.svg";